import { createApp } from 'vue'
import { configuration, dataLayer, privacy } from '@dpgradio/creative'
import './style.css'
import App from './App.vue'

const createKastaarsApp = async () => {
  await configuration.retrieveConfigForStation('qmusic_be')

  const app = createApp(App)

  app.mount('#app')

  privacy.initialize()
  dataLayer.initialize()
  dataLayer.pushVirtualPageView()
}

window.createVueApp = createKastaarsApp
window.createVueApp()
